var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"1587e95aae6985765e7e6b2b13727f735e2b8a8d"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["frontend-web@token-traxx"]={id:"1587e95aae6985765e7e6b2b13727f735e2b8a8d"};
      